import React from 'react'
import LogoImg from '../../images/layout/logo.svg'
import ZkCloudLogoImg from '../../images/cloud/layout/logo_home.svg'
import SologonImg from '../../images/signflow/sologon.jpg'
import ZkCloudSologonImg from '../../images/signflow/zkcloud_sologon.png'
import ScanLoginImg from "../../images/signflow/scanlogin.svg";
import AccountLoginImg from "../../images/signflow/pwdlogin.svg";
import {Button} from "antd";
import {Link} from "react-router-dom";
import IconSuccess from "../../iconfont/success";
import {Path} from "../public/path";

//登录页面logo
export const Header = () => {
    return <header className='qy-signflow-header'>
        <a href='home.html'>
            <img height={50} src={LogoImg}/>
        </a>
    </header>
};

export const ZkCloudHeader = () => {
    return <header className='qy-signflow-header'>
        <a href='home.html'>
            <img height={40} src={ZkCloudLogoImg}/>
        </a>
    </header>
};

//登录页面页脚
export const Footer = () => {
    return <footer className='qy-footer'>
        <p className='qy-footer-des'>
            <span className='qy-footer-des-line'></span>
            <span className='qy-footer-des-con'>紫鲲</span>
            <span className='qy-footer-des-dot'></span>
            <span className='qy-footer-des-con'>客户数字化运营与精准营销工具</span>
            <span className='qy-footer-des-line'></span>
        </p>
        <p className='qy-footer-icp'>Copyright © {new Date().format('yyyy')} 北京鲸湾科技有限公司 All Rights Reserved.
            京ICP备2021017567号</p>
    </footer>
};

export const ZkCloudFooter = () => {
    return <footer className='qy-footer'>
        <p className='qy-footer-des'>
            <span className='qy-footer-des-line'></span>
            <span className='qy-footer-des-con'>紫鲲</span>
            <span className='qy-footer-des-dot'></span>
            <span className='qy-footer-des-con'>客户数字化运营与精准营销工具</span>
            <span className='qy-footer-des-line'></span>
        </p>
        <p className='qy-footer-icp'>Copyright © {new Date().format('yyyy')} 北京鲸湾科技有限公司 All Rights Reserved.
            京ICP备2021017567号</p>
    </footer>
};

//登录页面sologon

export const Sologon = () => {
    return <div className='qy-signflow-form-left'>
        <img src={SologonImg}/>
    </div>
};

export const ZkCloudSologon = () => {
    return <div className='qy-signflow-form-left'>
        <img src={ZkCloudSologonImg}/>
    </div>
};

export const LoginTypeSwitch = ({type: type, typeChange: typeChange}) => {
    if (type) {
        switch (type) {
            case 'account':
                return <div className='login-type-switch'>
                    <img src={ScanLoginImg} onClick={typeChange}/>
                </div>;
            case 'wx':
                return <div className='login-type-switch'>
                    <img src={AccountLoginImg} onClick={typeChange}/>
                </div>;
        }
    }
    return ''
};

//登录按钮
export const LoginBtn = ({btnText: btnText, btnOnClick: btnOnClick, loginSwitch: loginSwitch, loading: loading}) => {
    return <div className='login-btn-wraper'>
        <Button className='login-btn' type='primary' onClick={btnOnClick} loading={loading}>{btnText}</Button>
        <p className='login-switch'>{loginSwitch}</p>
    </div>
};

//注册或重置密码成功页面
export const SuccessToLogin = ({title: title, target: target}) => {
    return <div className='login-wraper account-single'>
        <div className='account-login-wraper success2login'>
            <IconSuccess/>
            <p>{title}</p>
            <Link to={Path.getDashboard()} className='login-btn-wraper'><Button type='primary'
                                                                                className='login-btn'>立即登录</Button></Link>
        </div>
    </div>
};